import { http, HttpResponse } from 'msw'

import { allZones } from 'app/mocks/data/park/sites/zones'

import {
    api,
    isNumeric,
    SEARCH_PARAM_LIMIT,
    SEARCH_PARAM_OFFSET,
} from 'app/utils/constants'
import { searchParametersZoneApi } from 'app/utils/settings/zones'

import { ZoneRequest } from 'app/types/park/site'

export const getAllZones = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.park.sites.zones.LIST}`,
    ({ request }) => {
        const { searchParams } = new URL(request.url)
        const limitQuery = searchParams.get(SEARCH_PARAM_LIMIT)
        const offsetQuery = searchParams.get(SEARCH_PARAM_OFFSET)

        const managerId = searchParams.get(searchParametersZoneApi.MANAGER)

        let allZonesFiltered = allZones

        if (managerId) {
            allZonesFiltered = allZonesFiltered.filter(
                (zone) => zone.client.id.toString() === managerId,
            )
        }

        // Pagination
        const limit = isNumeric(limitQuery) ? Number(limitQuery) : 10
        const offset = isNumeric(offsetQuery) ? Number(offsetQuery) : 0

        const limitArray =
            allZonesFiltered.length > limit
                ? offset + limit
                : allZonesFiltered.length

        const results = allZonesFiltered.slice(offset, limitArray)

        const next =
            offset + results.length < allZonesFiltered.length
                ? 'again'
                : undefined

        return HttpResponse.json<ZoneRequest>({
            next,
            results,
        })
    },
)
